'use strict';

var React = require('react/addons');

var Module = React.createClass({
  displayName: 'Module',

  getDefaultProps: function getDefaultProps() {
    return {
      status: 'unknown',
      selected: false,
      position: { x: 0, y: 0 }
    };
  },

  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    var props = this.props;
    var position = props.position;

    return nextProps.status !== props.status || nextProps.selected !== props.selected || nextProps.position.x !== position.x || nextProps.position.y !== position.y;
  },

  render: function render() {
    var component = this;
    var cx = React.addons.classSet;

    var _component$props = component.props;
    var id = _component$props.id;
    var moduleType = _component$props.moduleType;
    var status = _component$props.status;
    var position = _component$props.position;
    var selected = _component$props.selected;
    var onStartDragging = _component$props.onStartDragging;
    var onTouchStartDragging = _component$props.onTouchStartDragging;
    var onClick = _component$props.onClick;

    var statusClasses = {};
    statusClasses.status = true;
    statusClasses[status] = true;

    var moduleClasses = {};
    moduleClasses.module = true;
    moduleClasses.selected = selected;

    var translations = moduleType.translations['en-US'];

    var inputNodes = moduleType.inputs.map(function (input) {
      var inputTranslation = translations[input.name + '_input'];
      return React.createElement(
        'div',
        {
          key: input.name,
          ref: "input_" + input.name,
          className: 'input',
          onMouseDown: component._onInputMouseDown.bind(null, input.name),
          onMouseUp: component._onInputMouseUp.bind(null, input.name),
          onTouchStart: component._onInputTouchStart.bind(null, input.name),
          onTouchEnd: component._onInputTouchEnd.bind(null, input.name) },
        inputTranslation
      );
    });

    var outputNodes = moduleType.outputs.map(function (output) {
      var outputTranslation = translations[output.name + '_output'];
      return React.createElement(
        'div',
        {
          key: output.name,
          ref: "output_" + output.name,
          className: 'output',
          onMouseDown: component._onOutputMouseDown.bind(null, output.name),
          onMouseUp: component._onOutputMouseUp.bind(null, output.name) },
        outputTranslation
      );
    });

    var transformStyle = 'translate3d(' + position.x + 'px,' + position.y + 'px,0px)';
    var moduleStyles = {
      'transform': transformStyle,
      WebkitTransform: transformStyle,
      MozTransform: transformStyle
    };

    return React.createElement(
      'div',
      {
        className: cx(moduleClasses),
        style: moduleStyles,
        onMouseDown: component._onMouseDown,
        onMouseUp: component._onMouseUp.bind(null, id),
        onTouchStart: component._onTouchStart,
        onTouchEnd: component._onTouchEnd.bind(null, id) },
      React.createElement(
        'div',
        { className: 'header', onMouseDown: onStartDragging.bind(null, id), onTouchStart: onTouchStartDragging.bind(null, id) },
        React.createElement(
          'div',
          { className: 'title' },
          moduleType.title
        ),
        React.createElement(
          'div',
          { className: 'subtitle' },
          moduleType.subtitle
        )
      ),
      React.createElement(
        'div',
        { className: 'content' },
        React.createElement(
          'div',
          { className: 'inputs' },
          inputNodes
        ),
        React.createElement(
          'div',
          { className: 'outputs' },
          outputNodes
        )
      )
    );
  },

  _onTouchStart: function _onTouchStart(evt) {
    console.log('module', 'onTouchStart');
    this._onMouseDown(evt.touches[0]);
  },

  _onMouseDown: function _onMouseDown(evt) {
    var component = this;
    var position = { x: evt.clientX, y: evt.clientY };

    component.clickTimeout = setTimeout(component._onSelectTimeout, 350);
    component.downPosition = position;
  },

  _onSelectTimeout: function _onSelectTimeout(moduleId) {
    this.clickTimeout = null;
  },

  _onTouchEnd: function _onTouchEnd(moduleId, evt) {
    console.log('module', 'onTouchEnd');
    this.props.onTouchEnd(evt);
    this._onMouseUp(moduleId, evt.changedTouches[0]);
  },

  _onMouseUp: function _onMouseUp(moduleId, evt) {
    evt.preventDefault();

    var component = this;
    var position = { x: evt.clientX, y: evt.clientY };
    var downPosition = component.downPosition;
    if (!downPosition) {
      return;
    }
    var delta = Math.sqrt(position.x - downPosition.x ^ 2 + (position.y - downPosition.y) ^ 2);
    var deltaThreshold = 2;

    if (delta > deltaThreshold) {
      return;
    }

    if (!component.clickTimeout) {
      return;
    }

    clearTimeout(component.clickTimeout);

    if (!component.props.onSelect) {
      return;
    }

    var metaKey = evt.metaKey;
    var ctrlKey = evt.ctrlKey;
    var altKey = evt.altKey;
    var shiftKey = evt.shiftKey;

    component.props.onSelect(moduleId, { metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey, shiftKey: shiftKey });
  },

  _onOutputTouchStart: function _onOutputTouchStart(name, evt) {
    evt.preventDefault();
    this._onOutputMouseDown(name);
  },

  _onOutputMouseDown: function _onOutputMouseDown(name) {
    var props = this.props;

    if (props.onStartOutput) {
      props.onStartOutput(name);
    }
  },

  _onOutputTouchEnd: function _onOutputTouchEnd(name, evt) {
    evt.preventDefault();
    this, _onOutputMouseUp(name);
  },

  _onOutputMouseUp: function _onOutputMouseUp(name) {},

  _onInputTouchStart: function _onInputTouchStart(name, evt) {
    evt.preventDefault();
    this, _onInputMouseDown(name);
  },

  _onInputMouseDown: function _onInputMouseDown(name) {},

  _onInputTouchEnd: function _onInputTouchEnd(name, evt) {
    evt.preventDefault();
    this, _onInputMouseUp(name);
  },

  _onInputMouseUp: function _onInputMouseUp(name) {
    var props = this.props;

    if (props.onStopInput) {
      props.onStopInput(name);
    }
  }
});

module.exports = Module;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module.js
 **/